module.exports = __webpack_public_path__ + "img/aqjnpx-img05.d62281df.png";